module.exports = __webpack_public_path__ + "static/media/  (64).1abbd042.jpg";